import React, { use, useEffect, useState } from 'react'
import './momentum-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faFilter, faPen, faPlus, faUpload } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import { format } from 'date-fns';
import { stripHtml } from '@/utils/sanitize';
import { useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { useSelector } from 'react-redux';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import ManagerElementListMenu from '@/components/SHARED/manager-element-list-menu/manager-element-list-menu.component';
import ManagerElementListItem from '@/components/SHARED/manager-element-list-item/manager-element-list-item.component';
import CategoryFilterModal from '../components/category-filter-modal.component';
import { sortElementsNoThe } from '@/utils/sortElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';

const MomentumList = ({
  gameElements,
  momentumCardsFromDb,
  gameData,
  role
}) => {

  const membership = useEffectiveMembership();
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [filteredElements, setFilteredElements] = useState([]);
  const [contentToDisplay, setContentToDisplay] = useState([]);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [menuCategory, setMenuCategory] = useState('visible');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [ categoryList, setCategoryList ] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [dropdown, setDropdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setContentToDisplay(sortElementsNoThe(filteredElements))
  }, [filteredElements])

  useEffect(() => {
    if (!momentumCardsFromDb) return;
    let cats = [];
    Object.values(momentumCardsFromDb).forEach(e => {
      if (e.opt_cat && !cats.includes(e.opt_cat)) {
        cats.push(e.opt_cat);
      }
    })
    setCategoryList(cats);
  }, [momentumCardsFromDb])

  function checkMembership(e) {
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'create': true });
    if (res.disabled && res.disabledReason.includes('elements')) {
      const planRest = membershipRestrictions[membership.membership];
      const message = `While using the ${planRest.title}, you are only able to have ${planRest.elementCount} active Game Elements per game.`;
      setShowUpgradeModal(message);
      return;
    }
    if (e === 'upload') {
      navigate('upload');
    } else {
      navigate('create');
    }
  }

  function search(e) {
    if (!e) {
      setContentToDisplay(sortElementsNoThe(filteredElements.filter(a => a.type === 'momentum')))
      return;
    }
    const filtered = filteredElements.filter(a => a.type === 'momentum' && (a.name.toLowerCase().includes(e) || a.desc && a.desc.toLowerCase().includes(e)))
    setContentToDisplay(sortElementsNoThe(filtered));
  }

  function chooseCategory(cat) {
        // console.log(cat);
        let tempCats = [...selectedCategories];
        // console.log(tempCats)
        if (tempCats.includes(cat)) {
            tempCats.splice(tempCats.indexOf(cat), 1)
        } else {
            tempCats.push(cat);
        }
        setSelectedCategories([...tempCats]);
    }

  return (
    <div className={`momentum-list ${screenSize}`}>
      {
        (screenSize !== 'mobile' && screenSize !== 'tablet') &&
        <ManagerElementListMenu
          gameElements={gameElements}
          elementsFromDb={momentumCardsFromDb}
          type='momentum'
          setContentToDisplay={setContentToDisplay}
          setDropdown={setDropdown}
          setFilteredElements={setFilteredElements}
          menuCategory={menuCategory}
          setMenuCategory={setMenuCategory} />
      }
      <div className='momentum-list-content'>
        <div className='buttons'>
          <button
            className={`g-button med-btn ${role !== 'manager' && role !== 'owner' ? 'disabled' : ''}`}
            onClick={() => checkMembership()} >
            Create a Momentum Card
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
        {
          (screenSize === 'mobile' || screenSize === 'tablet') &&
          <>
            <div className="g-space-1"></div>
            <ManagerElementListMenu
              gameElements={gameElements}
              elementsFromDb={momentumCardsFromDb}
              type='momentum'
              setContentToDisplay={setContentToDisplay}
              setDropdown={setDropdown}
              setFilteredElements={setFilteredElements}
              menuCategory={menuCategory}
              setMenuCategory={setMenuCategory} />

          </>
        }
        <div className="g-space-1"></div>
        <div className='momentum-list-search'>
          <SearchBar search={search} />
          <button
            type='button'
            className='g-button med-btn'
            title='Filter by Category'
            onClick={() => setShowFilterModal(true)} >
            <FontAwesomeIcon
              icon={faFilter}
              className={
                selectedCategories.length > 0
                  ? 'full'
                  : 'empty'
              }
            />
          </button>
          <button
            type='button'
            className={`g-button med-btn ${role !== 'manager' && role !== 'owner' ? 'disabled' : ''}`}
            title='Upload a List of Momentum Cards'
            onClick={() => checkMembership('upload')} >
            <FontAwesomeIcon icon={faUpload} />
          </button>
        </div>
        <div className="g-space-1"></div>
        <div className='momentum-list-div'>
          {
            (screenSize !== 'mobile' && screenSize !== 'tablet') &&
            <>
              <div className='g-list-item momentum-list-head element-list-row meta'>
                <div></div>
                <div>Name</div>
                {/* <div>Description</div> */}
                <div>Momentum</div>
                <div></div>
              </div>
              <div className='g-space-0-5'></div>
            </>
          }
          <div className='momentum-list'>
            {
              (contentToDisplay.length > 0)
                ?
                contentToDisplay
                  .map(c => (
                    <div key={c.id} >
                      <ManagerElementListItem
                        gameElements={gameElements}
                        gameData={gameData}
                        element={c}
                        dropdown={dropdown}
                        setDropdown={setDropdown}
                        dataPoint={c.opt_momentumDirection}
                        role={role} />
                    </div>
                  ))
                :
                <p>No Momentum Cards yet...</p>
            }
          </div>
        </div>
      </div>
      <CategoryFilterModal
        show={showFilterModal}
        cancel={() => setShowFilterModal(false)}
        chooseCategory={chooseCategory}
        categoryList={categoryList}
        selectedCategories={selectedCategories}
        text='Filter by Category'
        color='var(--primary)' />
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(false)}
        closeButton={true}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default MomentumList